import Image from "utils/imageLoader";

export const BuildInstructions = ({ build_steps, hardware_list }) => {
    // if (!build_steps || build_steps.length === 0) return null;
    return (
        <>
            {build_steps.map((current_step, idx) => (
                <div key={idx} className="project-detail-grid" style={{ marginBottom: '100px' }}>
                    <div className="project-detail-sidebar">
                        <Image
                            fileName={current_step?.preview_image_url || null}
                            alt={current_step.title || "Step Image"}
                            className="project-detail-image"
                        />
                    </div>

                    <div className="project-detail-content">
                        <h1 className="section-title">{current_step.title}</h1>

                        {current_step?.instructions &&
                            current_step.instructions.length > 0 && (
                                <div className="text-box">
                                    <h2>
                                        Instructions for step{" "}
                                        {current_step.index + 1}
                                    </h2>
                                    <ul className="feature-list">
                                        {current_step.instructions.map(
                                            (instruction, index) => (
                                                <li key={index}>
                                                    {instruction}
                                                </li>
                                            )
                                        )}
                                    </ul>
                                </div>
                            )}
                    </div>
                </div>
            ))}

            {hardware_list && hardware_list.length > 0 && (
                <div className="text-box files-section">
                    <h2>Required Hardware</h2>
                    <div className="files-list">
                        {hardware_list.map((hardware, index) => (
                            <div key={index} className="file-item">
                                <Image
                                    fileName={hardware?.preview_image_url || null}
                                    alt={hardware?.part_name || "Hardware"}
                                    className="file-preview"
                                />
                                <div className="file-info">
                                    <span className="file-name">
                                        {hardware?.part_name}
                                    </span>
                                    <span className="component-info">
                                         Weight: {hardware.weight || "-"} g
                                     </span>
                                    

                                    <span className="component-info">
                                        Quantity:{" "}
                                        {hardware?.quantity || 1}
                                    </span>
                                    {hardware?.part_number && (
                                        <span className="component-info">
                                            Part Number:{" "}
                                            {hardware.part_number}
                                        </span>
                                    )}
                                </div>
                                <a
                                    href={
                                        `${hardware.link}` ||
                                        "#"
                                    }
                                    download
                                    className={`btn btn-primary btn-sm ${
                                        !hardware.link
                                            ? "disabled"
                                            : ""
                                    }`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (hardware.link) {
                                            window.open(hardware.link, '_blank').focus();
                                        }
                                    }}
                                    style={{
                                        opacity: hardware.link
                                            ? 1
                                            : 0.5,
                                        cursor: hardware.link
                                            ? "pointer"
                                            : "not-allowed",
                                    }}
                                >
                                    Buy
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};
